<template>

	<div class="content" style="display: flex">
		<!-- 左 -->
		<div class="tableBox9" v-if="!qrCodeShow" ref="menuResize">
			<div class="tableMes">
				<div class="table newTable">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<!-- <el-tab-pane label="设备类型" name="first">
							<template v-if="treeShow">
								<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes" ref="treeDisplay"></tree>
							</template>
						</el-tab-pane> -->
						<el-tab-pane :label="$t('label_161')" name="second">
							<template v-if="treeShow">
                <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
<!--                <tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes"-->
<!--                      ref="treeDisplay2"></tree>-->
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<!-- <div class="dragBox" ref="dragResize"></div> -->
		</div>
		<!-- 右 -->
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<!-- <img style="width:100%;height:100%;" src="../../../static/img/buttonRight.png"> -->
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" ref="operaResize" :style="{'padding':width=='0px'?'0':'60px 0px 0px 350px '}">
			<div class="tableMes" style="height: 100%;">
				<div class="table">
					<!-- 主 -->
					<!-- 上 -->
					<div class="treeMes newTable" v-if="!eqDetail" style="padding: 0;">
						<div class="spotMesBox motebs" style="height:100%;width: 100%;">
							<p class="title" style="padding: 10px 10px 0 10px;"><span class="spot">{{'<'+(deviceDetailMes.name==undefined?$t('label_272'):deviceDetailMes.name)+">"}}</span>
								{{$t('label_1')}}</p>
							<el-tabs v-model="tabModel" @tab-click="handleClickSpot" style="height: calc(100% - 31px);">
								<el-tab-pane :label="$t('label_634')" name="organization">
									<stateParam v-if="organizationShow" ref="Param" :showButton="true" :needSort="true" @detailShow="detailShow"></stateParam>
								</el-tab-pane>
								<el-tab-pane :label="$t('label_557')" name="role">
									<deviceParam v-if="roleShow" ref="paramDisplay" :showButton="true" :needSort="true"></deviceParam>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<div class="treeMes" v-else>
						<eqDetail :eqId="eqId" @detailClose="detailClose"></eqDetail>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/equTree.vue";
  // import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import common from "@/assets/js/common/common.js";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";
	import exportMes from "@/components/list/export/export";
	import calendar from "@/components/list/calendar/calendar";
	import deviceParam from "@/components/list/monitoring/deviceParam";
	import stateParam from "@/components/list/monitoring/stateParam";
	import daily from "@/components/list/equipmentDetails/daily";
	import weekly from "@/components/list/equipmentDetails/weekly";
	import monthlyReport from "@/components/list/equipmentDetails/monthlyReport";
	import annualReport from "@/components/list/equipmentDetails/annualReport";
	import eqDetail from "@/components/list/equipmentDetails/eqDetail";

	export default {
		name: 'spotResumePage',
		components: {
			Page,
			tree,
			calendar,
			deviceParam,
			stateParam,
			daily,
			weekly,
			monthlyReport,
			annualReport,
			eqDetail
		},
		data() {
			return {
				organizationShow: true,
				roleShow: true,
				eqDetail: false,
				eqId: '',
				eqDetailInfo: {},
				eqTabs: 'eqDay',
				value1: '',
				value2: '',
				radio: '1',
				activeIndex: '1',
				treeProps: {
					label: 'name',
				},
				tabModel: 'organization',
				getTreeMes: '0',
				treeShow: true,
				MenuRoleList: [],
				newType: {
					name: '',
					operationState: '1',
					failureState: '1',
					lifeState: '1',
				},
				deviceDetailMes: {},
				tableChooseInfo: {},
				heightNum: '250',
				dialogDeviceSpot: false,
				dialogDeviceDetailMes: false,
				dialogEquDeviceAdd: false,
				editEqumentName: this.$t('label_460'),
				dialogDeviceBao: false,
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				dialogSpotBatchTimeEdit: false,
				monthDOptions: [],
				cardData: [],
				tableDataDeviceList: [],
				parameterData: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				mainEditTree: 'project',
				activeNameDevice: 'device',
				searchDataList: {},
				equipmentStatusList: {

				},
				deptIdList: ['0'],
				beginTime: '',
				endTime: '',
				workTime: {},
				lastArea: {},
				detailCloseShow: true,
				width: '340px',
				qrCodeShow: false,
				timer:null,
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
					test2(380)
					// this.$refs.menuResize.style.width = "0px";
					// this.$refs.operaResize.style.width = document.documentElement.clientWidth -240 +"px";
				} else {
					this.width = "340px";
					test2(-240)
					// this.$refs.menuResize.style.width = "340px";
					// this.$refs.operaResize.style.width = document.documentElement.clientWidth -340 +"px";
				}
				if (this.tabModel == 'organization') {
					if (this.qrCodeShow) {
						test3()
						// this.$refs.Param.newMes2(340);
					} else {
						test3()
						// this.$refs.Param.newMes2(-340);
					}
				}
			},
			//显示设备详细
			detailShow: function(eq) {
				this.eqId = eq.id;
				this.eqDetail = true;
			},
			// dropSize() {
			// 	let that = this,
			// 		menuWidth = 200,
			// 		operaHeight = 200;
			// 	this.$refs.dragResize.onmousedown = function() {
			// 		document.onmousemove = function(e) {
			// 			let clientX = e.clientX;
			// 			// 最大宽度
			// 			if (clientX >= 800) {
			// 				clientX = 800;
			// 			}
			// 			// 最小宽度
			// 			if (clientX <= 495) {
			// 				clientX = 495;
			// 				menuWidth = clientX - 30;
			// 			}
			// 			that.$refs.menuResize.style.width = clientX - 275 + "px";
			// 			that.$refs.operaResize.style.width = window.screen.width - clientX + 35 + "px";
			// 			document.onmouseup = function() {
			// 				document.onmousemove = null;
			// 				document.onmouseup = null;
			// 				that.releaseCapture && that.releaseCapture()
			// 			}
			// 		}
			// 	}
			// },
			// //关闭设备详细
			// detailClose: function() {
			// 	this.eqDetail = false;
			// },
			//查询上下班时间
			getWorkTime: function() {
				equipmentMonitoringService.getWorkTime().then((response) => {
					const data = response.data;
					if (data.code == "1") {
							this.workTime = data.data;
							this.beginTime = data.data.beginTime;
							this.endTime = data.data.endTime;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			//关闭设备详细信息
			detailClose: function() {
				this.eqDetail = false;
				this.getDeviceMes(this.lastArea);
			},
			// 顶部导航
			handleClickSpot(tab, event) {
				var $this = this;
				if (this.tabModel == 'organization') {
					this.organizationShow = false;
					this.$nextTick(function() {
						$this.organizationShow = true;
						this.$nextTick(function() {
							$this.$refs.Param.newMes(this.deviceDetailMes, this.beginTime, this.endTime); //状态监视
						})
					})
				} else {
					this.roleShow = false;
					this.$nextTick(function() {
						$this.roleShow = true;
						this.$nextTick(function() {
							$this.$refs.paramDisplay.newMes(this.deviceDetailMes, this.workTime); //状态列表
						})
					})
				}
			},
			// cimsInputClick () {
			//       window.location.href = '@/static/spotCountPage'
			//     },

			//从属于
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			// treeCheck(data, checked, indeterminate) {
			//   if (checked) {
			//     this.formModel.organizationId = data.id;
			//     this.cardData.deptId = data.id;
			//     this.$refs.tree.setCheckedKeys([data.id], true)
			//     this.selectDept(data.id);
			//     this.$refs.selectTree1.blur()
			//   }

			// },

			getDeviceMes(data) {
				this.lastArea = data;
				this.eqDetail = false;
				this.detailCloseShow = true;
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}

				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes.type = 2;
				} else {
					this.deviceDetailMes.type = data.type;
				}
				this.deviceDetailMes.name = data.name;
				this.deviceDetailMes.id = data.id;
				if (this.tabModel == 'organization') {
					this.$nextTick(function() {
						this.$refs.Param.newMes(this.deviceDetailMes, this.beginTime, this.endTime, ''); //状态监视
					})
				} else {
					this.$nextTick(function() {
						this.$refs.paramDisplay.newMes(this.deviceDetailMes, this.workTime, ''); //状态列表
					})
				}
			},

			handleClickTree(tab, event) {
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}
				this.deviceDetailMes.name = this.$t('label_272')
				// this.search()
			},
		},
		mounted() {
			// this.$nextTick(() => {
			// 	this.dropSize();
			// })
		},
		beforeDestroy() {
			// clearInterval(this.timer);
			// this.timer = null;
		},
		created() {
			// this.timer = setInterval(() => {
				this.getWorkTime();
			// }, 1000)
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style>
	.checkBoxs {
		width: 12px;
		height: 12px;
		float: left;
		margin-top: 4px;
	}

	.ceshi:hover {
		text-decoration: underline;
		color: #f00;
		cursor: pointer;
	}

	.widthstyle {
		width: 14%;
		font-weight: bold;
		font-size: 28px;
	}

	.type_style {
		font-weight: bold;
		color: #4BB699;
		font-size: 10px;
	}

	.down_box {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		border-top: 1px #CACACA solid;
		margin-top: 20px;
	}

	.title_style {
		font-weight: 600;
		margin-right: 80px;
	}

	.number_one {
		font-size: 30px;
		color: #1159C2;
		margin-left: 10px;
		margin-right: 10px;
	}

	.number_two {
		font-size: 20px;
		color: #929497;
	}

	.cehsi {
		width: 100%;
		height: 400px;
		display: flex;
	}

	.left_box {
		width: 25%;
		max-height: 400px;
		overflow-x: hidden;
		overflow-y: auto;
		border: 1px solid #E1E1E1;
	}

	.right_box {
		width: 75%;
		max-height: 400px;
		overflow-x: hidden;
		overflow-y: auto;
		border: 1px solid #E1E1E1;
		margin-left: 20px;
	}

	.left_title {
		width: 100%;
		height: 30px;
		line-height: 30px;
		background: #EFEFEF;
		font-weight: 600;
		padding-left: 30px;
		box-sizing: border-box;
	}

	.content_box {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		padding-left: 30px;
		box-sizing: border-box;
		border: 1px solid #E1E1E1;
	}

	.content_boxs {
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		padding-left: 30px;
		box-sizing: border-box;
		border: 2px solid #93D2C1;
	}

	.equipment_wid {
		width: 130px;
		margin-left: 10px;
	}

	.bjmodel {
		margin-left: 10px;
	}

	.img_box {
		width: 50%;
		height: 100%;
		border: 1px solid #000000;
		margin-left: 30px;
		margin-right: 30px;
	}

	#dialogImg .el-dialog {
		height: 600px;
	}

	#dialogImg .el-dialog__body {
		height: 546px;
		overflow: auto;
		padding: 0;
	}

	.motebs .el-tabs__content {
		height: 90%;
	}

	.motebs .el-tab-pane {
		height: 100%;
	}

	.newTable .el-tabs--card>.el-tabs__header .el-tabs__item {
		width: 315px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentOperation/quipmentMonitoring.vue